import { Icon } from "@iconify/react/dist/iconify.js";
import { Drawer, ScrollArea } from "@mantine/core";
import { useLocation } from "@remix-run/react";
import { useEffect, useMemo } from "react";

import {
  GetUserPermissionQuery,
  Permission,
} from "~/graphql/__generated__/types";
import { cn } from "~/lib/tw";
import useBreakPoint from "~/lib/use-break-point";

import { LinksGroup } from "../links-group";

type SerializedMenu = {
  child: Permission[];
} & Permission;

function serializeMenu(menu: Permission[]): SerializedMenu[] {
  if (!menu) {
    return [];
  }

  const parentsMenu = menu
    .filter((item) => !item.module?.parentId)
    .sort((a, b) =>
      a.module && a.module.order && b.module && b.module.order
        ? a.module.order - b.module.order
        : 1,
    ) as Permission[];

  const childrenMenu = parentsMenu.map((p) => {
    const child = menu
      .filter((c) => c.module?.parentId === p.module?.id)
      .sort((a, b) =>
        a.module && a.module.order && b.module && b.module.order
          ? a.module.order - b.module.order
          : 1,
      );
    return { ...p, child };
  }) as SerializedMenu[];

  return childrenMenu;
}

export default function MenuDrawer({
  menu,
  open,
  close,
}: {
  menu: Permission[];
  open: boolean;
  close: () => void;
}) {
  const isMobile = useBreakPoint("sm");
  const location = useLocation();
  useEffect(() => {
    if (isMobile && open) {
      close();
    }
  }, [location.pathname]);

  return (
    <Drawer
      opened={open}
      onClose={close}
      position="left"
      closeButtonProps={{
        icon: <Icon icon="tabler:x" className="text-red-500 h-5 w-5" />,
      }}
      size="sm"
      classNames={{
        body: "h-full",
        content: "overflow-hidden",
      }}
    >
      <nav className={cn("h-[95%] w-full pr-4 !pb-0 flex flex-col")}>
        <ScrollArea className="flex-1 -mx-4">
          <div className="">
            {serializeMenu(menu).map((item, idx) => {
              if (item.canRead && item.canAccess) {
                return (
                  <LinksGroup
                    module={item.module}
                    child={item.child}
                    key={`menu-p-${item.module?.name}-${idx}`}
                  />
                );
              } else {
                return null;
              }
            })}
          </div>
        </ScrollArea>

        {/*
         * Comment this section because dont need to change branch for now;
         */}
        {/* <div className={cn("-mx-4 p-4")}> */}
        {/*   <Box className="border border-solid border-[var(--mantine-color-gray-3)] p-4 rounded-md"> */}
        {/*     {isUserCanChangeBranch ? ( */}
        {/*       <> */}
        {/*         <BranchMenu activeBranch={activeBranch} /> */}
        {/*         <Divider my="sm" className="hidden lg:block" /> */}
        {/*       </> */}
        {/*     ) : null} */}
        {/**/}
        {/*     <UserButton */}
        {/*       email={user.email} */}
        {/*       name={user.username} */}
        {/*       image={profilePhotoUrl} */}
        {/*       employeeId={user.pegawaiId} */}
        {/*     /> */}
        {/*   </Box> */}
        {/* </div> */}
      </nav>
    </Drawer>
  );
}
